import { createContext } from "react";

export const UserContext = createContext(null); // value incase provider is not specified for a component
